var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames+ '_text'},[(_vm.data.resource_url)?_c('img',{class:_vm.classNames+ '_resource_img',attrs:{"src":_vm.data.resource_url,"lazy":""}}):_c('p',[_vm._v("你收到一条新消息，请打开抖音app查看")])])
}
var staticRenderFns = []

export { render, staticRenderFns }